import { useEffect } from "react";
import { sendHeartbeat } from "../services/EngPerformanceApi";

/**
 * تحديث 63 — رصد مدة النشاط الفعلي (جلسات الاستخدام): نبضة كل دقيقة فقط إذا تفاعل المستخدم خلالها
 * (نقر، ضغط مفتاح، تنقل بين الصفحات). لا يُرسل أي محتوى ولا تُرصد حركة الفأرة أو ما يُكتب.
 * الوقت الذي يبقى فيه النظام مفتوحاً بلا تفاعل لا يُحتسب.
 */
export default function useActivityHeartbeat(pathname) {
  useEffect(() => {
    let interacted = true;
    const mark = () => { interacted = true; };
    window.addEventListener("pointerdown", mark, { passive: true });
    window.addEventListener("keydown", mark, { passive: true });
    const send = () => {
      if (document.visibilityState === "hidden") return;
      if (!interacted) return;
      interacted = false;
      sendHeartbeat(true);
    };
    send();
    const t = setInterval(send, 60000);
    return () => {
      clearInterval(t);
      window.removeEventListener("pointerdown", mark);
      window.removeEventListener("keydown", mark);
    };
  }, []);
  useEffect(() => { if (pathname) sendHeartbeat(true); }, [pathname]);
}
